import { render, staticRenderFns } from "./UploadTemplatePreference.vue?vue&type=template&id=a0913160"
import script from "./UploadTemplatePreference.vue?vue&type=script&lang=js"
export * from "./UploadTemplatePreference.vue?vue&type=script&lang=js"
import style0 from "./UploadTemplatePreference.vue?vue&type=style&index=0&id=a0913160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports